import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import dayjs from 'dayjs';
import { InpockView, Divider } from 'inpock-ui-react';

import { OrdersDetailResponse } from '@/apis';
import { PageTitle, CashReceiptInfoSection, CashReceiptFooter, Dropdown } from '@/components';

const RedirectToOrders = (pathname: string) => {
  const ordersPath = pathname.split('/').slice(0, 4).join('/');
  return <Navigate to={ordersPath} />;
};

const TRADE_TYPE: Record<string, string> = {
  issue: '발행',
  issue_fail: '발행실패',
  cancel: '취소',
} as const;

export function CashReceipt() {
  const location = useLocation();
  const state = location.state as { order: OrdersDetailResponse };
  const [selectedDropdown, setSelectedDropdown] = useState<number>(0);

  if (!state) {
    return RedirectToOrders(location.pathname);
  }

  const { cash_receipts } = state.order.cash_receipt_info || {};
  const dropdownOptions = cash_receipts?.map((cashReceipt) => {
    const { trade_type, created_at } = cashReceipt;
    const dateStr = created_at ? dayjs(created_at).format('YYYY.MM.DD HH:mm') : '';
    return `${TRADE_TYPE[trade_type]}일자 | ${dateStr}`;
  });

  const onChangeDropdown = (index: number) => {
    setSelectedDropdown(index);
  };

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>현금영수증 | 인포크링크</title>
        </Helmet>
      </HelmetProvider>
      <InpockView>
        <div className="container">
          <PageTitle title="현금영수증" />
          <Divider spacing={[0, 20]} />
          <Dropdown options={dropdownOptions || []} onChange={onChangeDropdown} />
          <Divider spacing={[20, 0]} />
          {/* 구매자 정보 */}
          <CashReceiptInfoSection
            section="buyer"
            cashReceipt={{ ...state.order, index: selectedDropdown }}
          />
          <Divider />
          {/* 판매자 정보 */}
          <CashReceiptInfoSection section="seller" cashReceipt={state.order} />
          <Divider />
          {/* 금액 */}
          <CashReceiptInfoSection
            section="amount"
            cashReceipt={{ ...state.order, index: selectedDropdown }}
          />
          <Divider />
          <CashReceiptInfoSection
            section="total"
            cashReceipt={{ ...state.order, index: selectedDropdown }}
          />
          <CashReceiptFooter />
        </div>
      </InpockView>
    </>
  );
}
